import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Property } from '../models/property';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PropertyLookupStore } from '../../shared/lookup/property-lookup/property-lookup.store';
import { Observable } from 'rxjs/Observable';
import { PropertyLookupSummary } from '../../shared/models/property-lookup-summary';
import { tap, catchError } from 'rxjs/operators';
import { PioneerValidators } from '../../shared/utils/pioneer.validators';
import { PropertyLookupDetail } from '../../shared/models/property-lookup-detail';
import { PropertyLookupConverter } from '../utils/property-lookup-converter';
import { DropdownItem } from '../models/dropdown-item';
import { CommonDataStore } from '../service/common-data/common-data.store';
import { OnyxEvent } from '../models/event';
import { PioneerUtils } from '../utils/pioneer-utils';
import { Vendor } from '../models/vendor';

@Component({
  selector: 'pioneer-vendor-rate',
  templateUrl: './vendor-rate.component.html',
  styleUrls: [ './vendor-rate.component.css' ]
})
export class VendorRateComponent implements OnInit {

  @Output()
  canceled = new EventEmitter();

  @Output()
  accepted = new EventEmitter<Vendor>();

  @Input()
  property: Property;

  vendorRateForm: FormGroup;

  private readonly vendorFormControlsConfig = {
    'commissionRoomPercentage': [ null,
      [ Validators.required, PioneerValidators.range(0, 100), PioneerValidators.isInteger ] ],
    'commRetention': [ false, [ Validators.required ] ]
  };

  private readonly vendorFormValidators = {
    validator: Validators.compose([])
  };

  list = [];

  constructor(private formBuilder: FormBuilder,
              public propertyLookupStore: PropertyLookupStore,
              public commonDataStore: CommonDataStore) { }

  ngOnInit() {
    this.createForm();
    this.vendorRateForm.enable();
  }

  private createForm() {
    this.vendorRateForm = this.formBuilder.group(this.vendorFormControlsConfig, this.vendorFormValidators);
  }

  cancel() {
    this.canceled.emit();
  }

  get commissionRoomPercentage() { return this.vendorRateForm.get('commissionRoomPercentage'); }

  get commRetention() { return this.vendorRateForm.get('commRetention'); }

  addCommissionRate(): void {
    const vendor = new Vendor({
      commissionRoomPercentage:  this.commissionRoomPercentage.value,
      commRetention: this.commRetention.value
    });

    this.accepted.emit(PropertyLookupConverter.propertyToVendor(this.property, vendor));
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-rate/vendor-rate.component.ts